import jQuery from 'jquery'

window.jQuery          = window.$ = jQuery
window.__PUBLIC_PATH__ = '/fonts'

import 'bootstrap-italia/dist/css/bootstrap-italia.min.css'
import './css/main.css'